module.exports = __webpack_public_path__ + "img/story002@2x.cb598f07.webp";